[
  { "code": "AF", "nationality": "أفغاني" },
  { "code": "AL", "nationality": "ألباني" },
  { "code": "DZ", "nationality": "جزائري" },
  { "code": "AS", "nationality": "ساموي أمريكي" },
  { "code": "AD", "nationality": "أندوري" },
  { "code": "AO", "nationality": "أنغولي" },
  { "code": "AI", "nationality": "أنغويلي" },
  { "code": "AG", "nationality": "أنتيغوي أو بربودي" },
  { "code": "AR", "nationality": "أرجنتيني" },
  { "code": "AM", "nationality": "أرميني" },
  { "code": "AU", "nationality": "أسترالي" },
  { "code": "AT", "nationality": "نمساوي" },
  { "code": "AZ", "nationality": "أذربيجاني" },
  { "code": "BS", "nationality": "بهامي" },
  { "code": "BH", "nationality": "بحريني" },
  { "code": "BD", "nationality": "بنغلاديشي" },
  { "code": "BB", "nationality": "بربادوسي" },
  { "code": "BY", "nationality": "بيلاروسي" },
  { "code": "BE", "nationality": "بلجيكي" },
  { "code": "BZ", "nationality": "بليزي" },
  { "code": "BJ", "nationality": "بنيني" },
  { "code": "BM", "nationality": "برمودي" },
  { "code": "BT", "nationality": "بوتاني" },
  { "code": "BO", "nationality": "بوليفي" },
  { "code": "BA", "nationality": "بوسني أو هرزغوفي" },
  { "code": "BW", "nationality": "بوتسواني" },
  { "code": "BR", "nationality": "برازيلي" },
  { "code": "BN", "nationality": "بروني" },
  { "code": "BG", "nationality": "بلغاري" },
  { "code": "BF", "nationality": "بوركيني" },
  { "code": "BI", "nationality": "بوروندي" },
  { "code": "KH", "nationality": "كمبودي" },
  { "code": "CM", "nationality": "كاميروني" },
  { "code": "CA", "nationality": "كندي" },
  { "code": "CV", "nationality": "كابو فيردي" },
  { "code": "CF", "nationality": "أفريقي وسط" },
  { "code": "TD", "nationality": "تشادي" },
  { "code": "CL", "nationality": "تشيلي" },
  { "code": "CN", "nationality": "صيني" },
  { "code": "CO", "nationality": "كولومبي" },
  { "code": "KM", "nationality": "قُمري" },
  { "code": "CG", "nationality": "كونغولي" },
  { "code": "CR", "nationality": "كوستاريكي" },
  { "code": "HR", "nationality": "كرواتي" },
  { "code": "CU", "nationality": "كوبي" },
  { "code": "CY", "nationality": "قبرصي" },
  { "code": "CZ", "nationality": "تشيكي" },
  { "code": "DK", "nationality": "دنماركي" },
  { "code": "DJ", "nationality": "جيبوتي" },
  { "code": "DM", "nationality": "دومينيكي" },
  { "code": "DO", "nationality": "دومينيكي (جمهورية)" },
  { "code": "EC", "nationality": "إكوادوري" },
  { "code": "EG", "nationality": "مصري" },
  { "code": "SV", "nationality": "سلفادوري" },
  { "code": "GQ", "nationality": "غيني استوائي" },
  { "code": "ER", "nationality": "إريتري" },
  { "code": "EE", "nationality": "إستوني" },
  { "code": "ET", "nationality": "إثيوبي" },
  { "code": "FJ", "nationality": "فيجي" },
  { "code": "FI", "nationality": "فنلندي" },
  { "code": "FR", "nationality": "فرنسي" },
  { "code": "GA", "nationality": "غابوني" },
  { "code": "GM", "nationality": "غامبي" },
  { "code": "GE", "nationality": "جورجي" },
  { "code": "DE", "nationality": "ألماني" },
  { "code": "GH", "nationality": "غاني" },
  { "code": "GR", "nationality": "يوناني" },
  { "code": "GD", "nationality": "غرينادي" },
  { "code": "GT", "nationality": "غواتيمالي" },
  { "code": "GN", "nationality": "غيني" },
  { "code": "GW", "nationality": "غيني بيساوي" },
  { "code": "GY", "nationality": "غوياني" },
  { "code": "HT", "nationality": "هايتي" },
  { "code": "HN", "nationality": "هندوراسي" },
  { "code": "HU", "nationality": "مجري" },
  { "code": "IS", "nationality": "آيسلندي" },
  { "code": "IN", "nationality": "هندي" },
  { "code": "ID", "nationality": "إندونيسي" },
  { "code": "IR", "nationality": "إيراني" },
  { "code": "IQ", "nationality": "عراقي" },
  { "code": "IE", "nationality": "أيرلندي" },
  { "code": "IL", "nationality": "إسرائيلي" },
  { "code": "IT", "nationality": "إيطالي" },
  { "code": "JM", "nationality": "جامايكي" },
  { "code": "JP", "nationality": "ياباني" },
  { "code": "JO", "nationality": "أردني" },
  { "code": "KZ", "nationality": "كازاخستاني" },
  { "code": "KE", "nationality": "كيني" },
  { "code": "KR", "nationality": "كوري جنوبي" },
  { "code": "KW", "nationality": "كويتي" },
  { "code": "KG", "nationality": "قيرغيزستاني" },
  { "code": "LA", "nationality": "لاوسي" },
  { "code": "LV", "nationality": "لاتفي" },
  { "code": "LB", "nationality": "لبناني" },
  { "code": "LS", "nationality": "ليسوتو" },
  { "code": "LR", "nationality": "ليبيري" },
  { "code": "LY", "nationality": "ليبي" },
  { "code": "LT", "nationality": "ليتواني" },
  { "code": "LU", "nationality": "لوكسمبورغي" },
  { "code": "MG", "nationality": "مدغشقري" },
  { "code": "MW", "nationality": "مالاوي" },
  { "code": "MY", "nationality": "ماليزي" },
  { "code": "MV", "nationality": "مالديفي" },
  { "code": "ML", "nationality": "مالي" },
  { "code": "MT", "nationality": "مالطي" },
  { "code": "MR", "nationality": "موريتاني" },
  { "code": "MU", "nationality": "موريشيوسي" },
  { "code": "MX", "nationality": "مكسيكي" },
  { "code": "MD", "nationality": "مولدوفي" },
  { "code": "MC", "nationality": "موناكو" },
  { "code": "MN", "nationality": "منغولي" },
  { "code": "MA", "nationality": "مغربي" },
  { "code": "MZ", "nationality": "موزمبيقي" },
  { "code": "MM", "nationality": "ميانماري" },
  { "code": "NA", "nationality": "ناميبي" },
  { "code": "NP", "nationality": "نيبالي" },
  { "code": "NL", "nationality": "هولندي" },
  { "code": "NZ", "nationality": "نيوزيلندي" },
  { "code": "NI", "nationality": "نيكاراغوي" },
  { "code": "NE", "nationality": "نيجري" },
  { "code": "NG", "nationality": "نيجيري" },
  { "code": "NO", "nationality": "نرويجي" },
  { "code": "OM", "nationality": "عماني" },
  { "code": "PK", "nationality": "باكستاني" },
  { "code": "PA", "nationality": "بنمي" },
  { "code": "PG", "nationality": "بابوا غينيا الجديدة" },
  { "code": "PY", "nationality": "باراغواي" },
  { "code": "PE", "nationality": "بيروفي" },
  { "code": "PH", "nationality": "فلبيني" },
  { "code": "PL", "nationality": "بولندي" },
  { "code": "PT", "nationality": "برتغالي" },
  { "code": "QA", "nationality": "قطري" },
  { "code": "RO", "nationality": "روماني" },
  { "code": "RU", "nationality": "روسي" },
  { "code": "RW", "nationality": "رواندي" },
  { "code": "SA", "nationality": "سعودي" },
  { "code": "SN", "nationality": "سنغالي" },
  { "code": "RS", "nationality": "صربي" },
  { "code": "SG", "nationality": "سنغافوري" },
  { "code": "SK", "nationality": "سلوفاكي" },
  { "code": "SI", "nationality": "سلوفيني" },
  { "code": "SO", "nationality": "صومالي" },
  { "code": "ZA", "nationality": "جنوب أفريقي" },
  { "code": "ES", "nationality": "إسباني" },
  { "code": "LK", "nationality": "سريلانكي" },
  { "code": "SD", "nationality": "سوداني" },
  { "code": "SE", "nationality": "سويدي" },
  { "code": "CH", "nationality": "سويسري" },
  { "code": "SY", "nationality": "سوري" },
  { "code": "TW", "nationality": "تايواني" },
  { "code": "TJ", "nationality": "طاجيكستاني" },
  { "code": "TZ", "nationality": "تنزاني" },
  { "code": "TH", "nationality": "تايلندي" },
  { "code": "TG", "nationality": "توغولي" },
  { "code": "TT", "nationality": "ترينيدادي أو توباغو" },
  { "code": "TN", "nationality": "تونسي" },
  { "code": "TR", "nationality": "تركي" },
  { "code": "TM", "nationality": "تركمانستاني" },
  { "code": "UG", "nationality": "أوغندي" },
  { "code": "UA", "nationality": "أوكراني" },
  { "code": "AE", "nationality": "إماراتي" },
  { "code": "GB", "nationality": "بريطاني" },
  { "code": "US", "nationality": "أمريكي" },
  { "code": "UY", "nationality": "أوروغواي" },
  { "code": "UZ", "nationality": "أوزبكستاني" },
  { "code": "VE", "nationality": "فنزويلي" },
  { "code": "VN", "nationality": "فيتنامي" },
  { "code": "YE", "nationality": "يمني" },
  { "code": "ZM", "nationality": "زامبي" },
  { "code": "ZW", "nationality": "زيمبابوي" }
]

